import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
const painPoints = ['Llegás a clase sin saber exactamente qué secuencia vas a dar ni cómo conectarla con lo de la semana pasada', 'Tus alumnos no progresan porque no hay un orden claro de contenidos de un mes al otro', 'Tenés grupos con edades mezcladas y no sabés cómo manejar los diferentes niveles de desarrollo', 'Cuando hay feriado o ausencia perdés la continuidad de lo aprendido y sentís que empezás de cero', 'No podés justificar un aumento de cuota porque no tenés nada sistematizado que mostrarle a los padres', 'Los padres te preguntan "¿qué aprendió mi hijo?" y no sabés cómo explicarlo sin sonar improvisada', 'Llegás a octubre sin saber qué van a bailar en la muestra y el estrés te consume todo noviembre', 'Nadie valora tu trabajo como docente porque no se ve reflejado en resultados concretos y visibles'];
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-234">
      <div className="max-w-4xl mx-auto px-4" data-id="element-235">
        <div className="text-center mb-12" data-id="element-236">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-237">
            Si sos profe de danza infantil, esto{' '}
            <br className="hidden sm:block" data-id="element-238" />
            <span className="text-wine-700" data-id="element-239">te va a sonar conocido:</span>
          </h2>
        </div>

        <div className="space-y-4 mb-16" data-id="element-240">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-start gap-4 bg-cream-50/80 p-4 rounded-xl border border-cream-100" data-id="element-241">
              <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-242">❌</span>
              <p className="text-gray-800 font-medium" data-id="element-243">{point}</p>
            </motion.div>)}
        </div>

        <div className="text-center mb-20" data-id="element-244">
          <p className="font-handwriting text-4xl text-wine-700 mb-8 transform -rotate-2" data-id="element-245">
            "¿Cuántas clases más vas a improvisar?"
          </p>
          <Button href="#precio" variant="primary" size="xl" data-id="element-246">
            👉 BASTA DE IMPROVISAR — QUIERO MI DANZA INFANTIL 360
          </Button>
        </div>

        {/* System Intro */}
        <div className="bg-gradient-to-br from-plum-900 to-plum-800 rounded-3xl p-8 md:p-12 text-white text-center shadow-2xl relative overflow-hidden" data-id="element-247">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-248">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-249">
              <defs data-id="element-250">
                <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-251">
                  <circle cx="2" cy="2" r="2" fill="currentColor" data-id="element-252" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#dots)" data-id="element-253" />
            </svg>
          </div>

          <div className="relative z-10" data-id="element-254">
            <h3 className="font-serif text-3xl md:text-4xl font-bold mb-4 text-gold-100" data-id="element-255">
              🏆 El Sistema N°1 para Profesoras{' '}
              <br className="hidden sm:block" data-id="element-256" />
              de Danza Infantil Argentinas
            </h3>
            <p className="text-xl text-cream-100 mb-10 max-w-2xl mx-auto" data-id="element-257">
              DANZA INFANTIL 360 — Colección Completa 12 Tomos + 6 Bonus + 2
              Elite — Todo resuelto, todos los niveles, todos los ciclos.
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-258">
              <StatCard value="+280" label="páginas" data-id="element-259" />
              <StatCard value="+120" label="ejercicios graficados" data-id="element-260" />
              <StatCard value="Todos" label="los niveles" data-id="element-261" />
              <StatCard value="3 ciclos" label="completos (3 a 8 años)" data-id="element-262" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function StatCard({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-white/10" data-id="element-263">
      <p className="text-3xl font-bold text-gold-300 mb-1" data-id="element-264">{value}</p>
      <p className="text-sm text-cream-100 font-medium leading-tight" data-id="element-265">
        {label}
      </p>
    </div>;
}